<template>
  <v-tabs color="transparent" slider-color="primary">
    <v-tab :ripple="false" v-for="lang in langs" :key="lang">
      <v-icon
        v-if="errors[`title.${lang}`] || errors[`description.${lang}`]"
        size="0.8rem"
        class="mr-1"
        color="red"
      >fas fa-exclamation</v-icon>
      <span>{{ lang }}</span>
    </v-tab>

    <v-tab-item touch v-for="lang in langs" :key="lang">
      <TabItemContent class="mt-1" :form="form" :errors="errors" :lang="lang" />
    </v-tab-item>
  </v-tabs>
</template>

<script>
import TabItemContent from "./TabItemContent";
export default {
  props: ["form", "errors"],
  components: { TabItemContent },
  data() {
    return {
      langs: ["fi", "se", "en"],
    };
  },
};
</script>